import { Injectable } from '@angular/core';
import { DataService } from '../common/data.service';
@Injectable({
  providedIn: 'root'
})
export class BulkUploadService {

  constructor(private _data: DataService) { }

  /*******************************Service Methods*************************************/
  BulkUploadEmployeeRecovery = (ID: any): any => {
    return this._data.PostData('BulkEmployeeRecovery/SaveEmployeeRecovery', ID);
  }

  GetAllAssetMasterList = (data: any): any => {
    return this._data.PostData('AssetMaster/GetAllAssetMasterList', data);
  }

  GetAssetMasterDataByID = (ID: string): any => {
    return this._data.GetDataById('AssetMaster/GetAssetMasterByID', ID);
  }

  DeleteAssetMaster = (ID: string): any => {
    return this._data.GetDataById('AssetMaster/DeleteAssetMasterByID', ID);
  }
  /**********************************END*********************************************/

  // **************************************Upload Excel Asset ***************************//
  GetAllUploadResponseList = (): any => {
    return this._data.GetData('UploadResponse/GetAllUploadResponseList');
  }
  UploadClientResponseData = (data: any): any => {
    return this._data.postfile('BulkUpload/UploadEmployeeRecoveryData', data);
  }
  SaveApprovalAttachments = (data: any): any => {
    return this._data.PostData('AssetMaster/SaveAttachments', data);
  }
  AddServiceRequest = (formData): any => {
    return this._data.PostData('PMCCalendar/AddServiceRequest', formData);
  }
  ExportData = (data: any): any => {
    return this._data.DownloadFileWithPost('AssetMaster/ExportToExcel', data);
}
  // ***************************************End ****************************************//
}
